<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Sayfa"
    }
</script>

<style scoped>

</style>